class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
  if (!this.animations) {
    this.animations = this.content.getAnimations();
  }

  if (this.mainDetailsToggle.hasAttribute('open')) {
    this.animations.forEach((animation) => animation.play());
  }
}

  close() {
  this.content.classList.add('menu-closing');

  setTimeout(() => {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);

    this.content.classList.remove('menu-closing');
  }, 180);
}
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');

    if (window.innerWidth < 990) return;

    this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // Em tablets e ecrãs táteis, o <summary> nativo controla a abertura
    // por toque. Não associar pointerenter evita abrir ao pressionar e
    // fechar novamente quando o click é disparado ao largar o dedo.
    if (!this.canHover) return;

    this.closeTimer = null;

    this.addEventListener('pointerenter', () => {
      clearTimeout(this.closeTimer);
      this.openMenu();
    });

    this.addEventListener('pointerleave', (event) => {

  clearTimeout(this.closeTimer);

  const next = event.relatedTarget;

  // Se o rato continua dentro deste header-menu, não fechar
  if (next && this.contains(next)) {
    return;
  }

  this.closeTimer = setTimeout(() => {

    if (!this.matches(':hover')) {
      this.closeMenu();
    }

  }, 180);

});
  }

  openMenu() {

    clearTimeout(this.closeTimer);

    this.content.classList.remove('menu-closing');

    document.querySelectorAll('header-menu details[open]').forEach((details) => {

        if (details !== this.mainDetailsToggle) {
            details.removeAttribute('open');
        }

    });

    // Se já está aberto, não reiniciar animações
    if (this.mainDetailsToggle.open) {
        return;
    }

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', 'true');

    this.content.classList.remove('animate-items');
    void this.content.offsetWidth;
    this.content.classList.add('animate-items');

    this.content.classList.remove('shine');
    void this.content.offsetWidth;
    this.content.classList.add('shine');

    if (this.header) {

        this.header.preventHide = true;

        if (
            document.documentElement.style.getPropertyValue(
                '--header-bottom-position-desktop'
            ) === ''
        ) {

            document.documentElement.style.setProperty(
                '--header-bottom-position-desktop',
                `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
            );

        }
    }
}

  closeMenu() {

    this.content.classList.add('menu-closing');

    this.closeTimer = setTimeout(() => {

    // Se o rato já voltou ao menu, cancelar o fecho
    if (this.matches(':hover')) {
        this.content.classList.remove('menu-closing');
        return;
    }

    this.mainDetailsToggle.removeAttribute('open');

    this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', 'false');

    this.content.classList.remove('menu-closing');

    if (this.header) {
        this.header.preventHide = false;
    }

}, 180);

  }

  onToggle() {
    super.onToggle();
  }
}

customElements.define('header-menu', HeaderMenu);